import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
import { PlusLg } from 'react-bootstrap-icons';

import { WidgetsContext, AppContext } from '../../GlobalContex';

import Loader from '../builder/Interface/Loader/Loader';
import TopBar from '../builder/Interface/TopBar/TopBar';
import SettingsPanel from '../settings-panel/SettingsPanel.js';

import styles from './WidgetCreator.module.css';
import useNotifications from '../../hooks/useNotifications';
import { useAnalytics } from '../../hooks/useAnalytics';

const SiteCreator = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const notification = useNotifications();
  const { sendEvent } = useAnalytics();
  const params = useParams();

  const {
    widgets,
    applications,
    createWidget,
    activeWidget,
    setActiveWidget,
    loadApplications,
    dispatchApplications,
    contextWidget
  } = useContext(WidgetsContext);

  const { isEmbeded } = useContext(AppContext);

  const createNewWidget = async appName => {
    try {
      const widget = await createWidget({ app: appName });
      setActiveWidget(widget);
      sendEvent('create_widget', {
        widget: appName
      });
      navigate(`/widgets/${widget.id}/builder`);
    } catch (error) {
      notification.error(error.message);
    }
  };

  useEffect(() => {
    if (!params?.widgetname) return;
    if (!widgets.length) {
      createNewWidget(params.widgetname);
    } else {
      let lastCreatedWidget = widgets
        .slice()
        .reverse()
        .find(item => item.app.name === params.widgetname);
      if (!lastCreatedWidget) {
        createNewWidget(params.widgetname);
      } else {
        setActiveWidget(lastCreatedWidget);
        //remake after server changes
        lastCreatedWidget?.settings?.account || lastCreatedWidget?.settings?.channel
          ? navigate(`/home`)
          : navigate(`/widgets/${lastCreatedWidget.id}/builder`);
      }
    }
  }, []);

  useEffect(() => {
    if (!applications?.length) {
      setIsLoading(true);

      loadApplications()
        .then(apps => {
          const detectWidget = apps.filter(item => {
            item.name === params.widgetname;
          });
          if (isEmbeded && detectWidget.length) {
            dispatchApplications(detectWidget);
          }
        })
        .catch(() => setIsLoading(false));
    }
  }, [applications.length]);

  useEffect(() => {
    if (isLoading) setIsLoading(false);
  }, [applications.length]);

  const Icon = path => {
    const assetsLocation = 'assets/';
    return <img className="me-3" src={assetsLocation + path} height="24" width="24" />;
  };

  return (
    <div className="bootstrap-app-styles builder-styles">
      <TopBar
        onClick={() => {
          navigate(-1);
        }}
      >
        {t('Create Widget')}
      </TopBar>
      <SettingsPanel>
        {isLoading ? (
          <>
            <p className={'text-center'}>{t('Creating a new page...')}</p>
            <Loader />
          </>
        ) : (
          applications.map(app => {
            if (isEmbeded() && app.name !== contextWidget.app?.name) return;
            return (
              <div className="mb-3" key={app.id}>
                <Card
                  className={styles.cardItem + ' mt-3'}
                  onClick={e => createNewWidget(app.name)}
                >
                  <Card.Body>
                    <div className="d-flex align-items-center">
                      {Icon(app.icon)}
                      <Card.Title className="m-0">{app.title}</Card.Title>
                      <PlusLg className="ms-auto" size={24} />
                    </div>
                  </Card.Body>
                </Card>
              </div>
            );
          })
        )}
      </SettingsPanel>
    </div>
  );
};

export default SiteCreator;
